// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","fileButtonText":"styles_fileButtonText__Vbygi","loading":"styles_loading__-DI0l","rotate":"styles_rotate__qDS51"};